import map from 'lodash/map'
import React, { FC } from 'react'

import { BlockContainer } from '@Components/BlockContainer'
import { ProductSlider } from '@Domains/Product/Features/ProductSlider/ProductSlider'
import { Product } from '@Generated/graphql'
import { useTranslation } from '@Globals/Translations'

import styles from '../Display.module.scss'

interface ProductVariationsProps {
  sizes: Product[]
  variations: Product[]
}

export const ProductVariations: FC<ProductVariationsProps> = ({ sizes, variations }) => {
  const { t } = useTranslation()

  const sliderSizeProducts = map(sizes, item => ({
    ...item,
    sourceID: 'linked_products_size',
  }))

  const sliderVariationProducts = map(variations, item => ({
    ...item,
    sourceID: 'linked_products_variation',
  }))

  const products = [
    ...sliderVariationProducts,
    ...sliderSizeProducts,
  ]

  return (
    <BlockContainer
      appearance={{
        backgroundColor: 'var(--green-500)',
        textColor: 'var(--white)',
      }}
      className={styles.productSliderWrapper}
      common={{
        position: 'left',
        title: t('products:VARIATIONS'),
        titleElement: 'h2',
        text: {
          key: 'cms:SIMILAR_PRODUCTS_LABEL',
          value: {
            children: [
              {
                children: [
                  {
                    text: t('cms:SIMILAR_PRODUCTS_LABEL'),
                  },
                ],
                type: 'p',
              },
            ],
          },
        },
      }}
    >
      <ProductSlider
        className={styles.productSlider}
        products={products}
        sourceID="linked_products_variations"
      />
    </BlockContainer>
  )
}

